// extracted by mini-css-extract-plugin
module.exports = {"trendIndicator":"styles_trendIndicator__3EGDl","trendIndicatorArrow":"styles_trendIndicatorArrow__3JoKu","positive":"styles_positive__2NViu","negative":"styles_negative__3i2Ru"};